
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinwakadpune() {



    const cardData =
    {
        keyword: 'Cab Service in Wakad Pune',
        heading: 'Platinum24 Cabs: Cab Service in Wakad Pune',
        headingDescription: ' Platinum24 Cabs offers dependable Cab Service in Wakad Pune, catering to residents, IT professionals, students, and corporate travelers in this growing hub. Our fleet of hatchbacks, sedans, SUVs, and luxury cars ensures safe, comfortable, and affordable rides for local commutes, airport transfers, and outstation journeys. With professional chauffeurs, punctual pickups, and transparent fares, we provide stress-free travel across Pune and nearby cities. Whether it’s a quick ride to Hinjewadi, a family outing, or a long-distance trip, Platinum24 Cabs guarantees 24/7 availability, reliable service, and a comfortable travel experience in Wakad.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, was the grand seat of the Peshwas of the Maratha Empire. Its mighty gates, fountains, and sprawling courtyards narrate tales of Bajirao and Mastani. Although partially destroyed by fire in 1828, the ruins still showcase Maratha pride. The evening light-and-sound show recreates historical glory. History lovers and tourists are drawn to its corridors and gardens. Shaniwar Wada is Pune’s proud symbol of heritage."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a majestic monument associated with India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. Today, it houses a museum displaying Gandhi’s belongings and photographs. Its Italian arches and sprawling gardens add elegance. It is also the memorial site of Kasturba Gandhi. Aga Khan Palace is Pune’s historic gem of peace and inspiration."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, 25 km from Pune, is remembered for the 1670 battle where Tanaji Malusare fought for Chhatrapati Shivaji Maharaj. The hilltop fort offers panoramic views of the Sahyadris and trekking trails. Visitors explore bastions, temples, and memorials that echo Maratha valor. Monsoon brings mist and waterfalls, enhancing the experience. Local villagers serve traditional pithla-bhakri at the summit. Sinhagad is Pune’s blend of history, trekking, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine dedicated to Lord Ganesha. The idol, richly decorated with gold, attracts lakhs of devotees. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. It is also renowned for its social and charitable works. The temple’s spiritual aura draws both locals and tourists. Dagdusheth Ganpati is Pune’s divine cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. It features massive stone pillars, a sanctum, and a Nandi mandapa. Despite being in the city’s center, it provides peace and spirituality. Evening prayers add a mystical touch. Its ancient rock carvings reflect early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage temple."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a cultural treasure with over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include musical instruments, ornaments, sculptures, and everyday antiques. The recreated Mastani Mahal is a major attraction. Students and history enthusiasts find it highly educational. The museum preserves India’s cultural legacy. It is Pune’s proud showcase of heritage and art."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers breathtaking views of the city. The hilltop temple complex is dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the shrine, blending devotion with adventure. Smaller shrines and a museum enrich its heritage value. Sunsets and sunrises are especially mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "Osho International Meditation Resort in Koregaon Park is a world-renowned center for spirituality and wellness. Spread across lush gardens, it offers meditation, yoga, and therapy programs. Its Zen gardens and modern lifestyle blend attract seekers worldwide. Visitors experience relaxation, rejuvenation, and inner peace. It is Pune’s global destination for mindfulness. Osho Ashram is the city’s international retreat of tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features streams, stone bridges, and beautifully manicured lawns. Families enjoy walks, picnics, and photography here. Seasonal flowers and lush greenery make it picturesque year-round. It symbolizes Indo-Japanese friendship. Pu La Deshpande Garden is Pune’s green paradise of calm."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular weekend spot near Pune. It provides water to the city and scenic landscapes for visitors. Monsoon makes it especially beautiful with overflowing streams. Vendors selling hot corn and tea add to the charm. It is also the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural retreat."
  }
],


  "services": [
    {
      "name": "Wakad Cab Service Pune",
      "description": "Experience reliable and convenient Wakad Cab Service in Pune, tailored to meet your daily commute and special travel needs. Our fleet of well-maintained vehicles and professional drivers ensure safe, punctual, and comfortable rides across Wakad and surrounding areas."
    },
    {
      "name": "Cab Booking Wakad Pune",
      "description": "Easily book your cab in Wakad Pune with our user-friendly online platform or phone service. Choose from a variety of vehicle options to suit your requirements, whether for local rides, airport transfers, or outstation trips."
    },
    {
      "name": "Taxi Service in Wakad",
      "description": "Our Taxi Service in Wakad offers affordable, timely, and professional transportation solutions. Whether you need a quick local ride or a full-day hire, our experienced drivers and clean cabs provide the perfect travel experience."
    },
    {
      "name": "Wakad Local Cab",
      "description": "Get around Wakad conveniently with our Wakad Local Cab service, designed for short-distance trips within the locality. Our cabs are available for quick errands, office commutes, shopping trips, or airport transfers."
    },
    {
      "name": "Affordable Cab in Wakad Pune",
      "description": "Travel smart with our Affordable Cab service in Wakad Pune, offering competitive rates without compromising on comfort or safety. Perfect for budget-conscious travelers seeking dependable transportation."
    },
    {
      "name": "Wakad Taxi with Driver",
      "description": "Enjoy stress-free travel with our Wakad Taxi service that comes with a professional driver. Our chauffeurs are courteous, punctual, and familiar with local routes to ensure a smooth journey every time."
    },
    {
      "name": "Wakad Outstation Cab Service",
      "description": "Planning a trip beyond Wakad? Our Outstation Cab Service offers comfortable and reliable transportation for outstation travel, be it weekend getaways or business trips, with well-maintained vehicles and experienced drivers."
    },
    {
      "name": "Wakad Airport Taxi",
      "description": "Catch your flights on time with our Wakad Airport Taxi service, offering timely pickups and drop-offs to Pune Airport. Our drivers track flight schedules to avoid delays and ensure a hassle-free airport transfer."
    },
    {
      "name": "Wakad Cab Rental",
      "description": "Rent a cab in Wakad for flexible travel options, whether it’s for a few hours or multiple days. Our rental service provides a variety of vehicles with drivers to accommodate family outings, corporate events, or sightseeing tours."
    },
    {
      "name": "Cab Service Near Wakad Pune",
      "description": "Find dependable cab services near Wakad Pune easily with us. Our extensive network guarantees prompt service no matter where you are in or around Wakad, ensuring quick and safe rides."
    },
    {
      "name": "Wakad Taxi Deals",
      "description": "Take advantage of exclusive Wakad Taxi Deals offering discounted rates on local, airport, and outstation rides. Our promotional offers make travel more affordable without sacrificing quality."
    },
    {
      "name": "Wakad City Taxi",
      "description": "Navigate through Wakad and Pune city effortlessly with our Wakad City Taxi service. Perfect for daily commutes, shopping trips, or leisure rides, our city taxis offer comfort, safety, and affordability."
    },
    {
      "name": "Wakad Corporate Cab",
      "description": "Professional and punctual, our Wakad Corporate Cab service caters to business travelers and companies looking for reliable employee transportation. Customized packages and priority bookings are available."
    },
    {
      "name": "Wakad Cab Online Booking",
      "description": "Book your Wakad cab easily online using our intuitive platform. Enjoy instant confirmation, secure payment options, and 24/7 customer support to ensure your booking experience is smooth and convenient."
    },
    {
      "name": "Wakad Family Cab Service",
      "description": "Travel comfortably with your loved ones using our Wakad Family Cab Service. Spacious vehicles, safe driving, and friendly drivers make it the perfect choice for family outings, celebrations, or trips."
    }
  ],
  "tableData": [
    ["Wakad Cab Service Pune", "Cab Booking Wakad Pune"],
    ["Taxi Service in Wakad", "Wakad Local Cab"],
    ["Affordable Cab in Wakad Pune", "Wakad Taxi with Driver"],
    ["Wakad Outstation Cab Service", "Wakad Airport Taxi"],
    ["Wakad Cab Rental", "Cab Service Near Wakad Pune"],
    ["Wakad Taxi Deals", "Wakad City Taxi"],
    ["Wakad Corporate Cab", "Wakad Cab Online Booking"],
    ["Wakad Family Cab Service", "—"]
  ],


          "whychoose": [
    {
      "WhyChooseheading": "Reliable Cab Service in Wakad Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers dependable and prompt cab services in Wakad for hassle-free local travel."
    },
    {
      "WhyChooseheading": "Quick Pickup with Nearby Drivers",
      "WhyChoosedescription": "Our drivers are strategically positioned in Wakad to ensure minimal wait times and fast service."
    },
    {
      "WhyChooseheading": "Clean and Comfortable Vehicles",
      "WhyChoosedescription": "Travel in sanitized, air-conditioned cabs that prioritize your comfort and safety."
    },
    {
      "WhyChooseheading": "Experienced Drivers with Local Knowledge",
      "WhyChoosedescription": "Our professional drivers know Wakad and surrounding areas well to provide smooth rides."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Enjoy upfront rates with no hidden charges, including fuel and tolls."
    },
    {
      "WhyChooseheading": "24/7 Customer Support for Easy Booking",
      "WhyChoosedescription": "Our team is available round-the-clock to assist with cab bookings and queries."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for All Travel Needs",
      "WhyChoosedescription": "Choose from local rides, outstation trips, or hourly rentals based on your schedule."
    },
    {
      "WhyChooseheading": "Multiple Vehicle Options to Suit Your Requirements",
      "WhyChoosedescription": "Select from hatchbacks, sedans, SUVs, or larger vehicles depending on your group size."
    }
  ]


























    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs provide cab services in Wakad, Pune?',
        answer: 'Yes, Platinum24 Cabs offers reliable and comfortable cab services in Wakad, Pune for local travel and beyond.',
    },
    {
        question: 'How can I book a cab in Wakad, Pune with Platinum24 Cabs?',
        answer: 'You can easily book your Wakad cab through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of vehicles are available for cab service in Wakad?',
        answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and tempo travellers to suit your travel needs.',
    },
    {
        question: 'Are the drivers experienced for local Wakad travel?',
        answer: 'Yes, all our drivers are professional, experienced, and familiar with Wakad and surrounding areas.',
    },
    {
        question: 'Can I book a cab for hourly or daily use in Wakad?',
        answer: 'Absolutely! We provide flexible hourly and daily rental options for cab services in Wakad.',
    },
    {
        question: 'Are the vehicles sanitized and safe for passengers?',
        answer: 'Yes, all vehicles are regularly sanitized, and our drivers follow strict safety and hygiene protocols.',
    },
    {
        question: 'Can I customize pickup and drop-off locations within Wakad?',
        answer: 'Yes, you can specify your preferred pickup and drop-off points anywhere in Wakad.',
    },
    {
        question: 'What payment methods are accepted for cab service in Wakad?',
        answer: 'We accept cash, credit/debit cards, and digital wallets for your convenience.',
    },
    {
        question: 'Is 24x7 cab service available in Wakad?',
        answer: 'Yes, our cab services in Wakad are available 24x7 to meet your travel needs.',
    },
    {
        question: 'Does Platinum24 Cabs provide corporate cab services in Wakad?',
        answer: 'Yes, we offer customized corporate cab solutions with priority support and flexible billing for clients in Wakad.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Aditya Joshi',
        feedback: 'The cab service in Wakad by Platinum24 Cabs was punctual and the vehicle was very comfortable.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Neha Desai',
        feedback: 'Great experience with Platinum24 Cabs in Wakad. The driver was professional and the booking process was seamless.',
        rating: 5,
    },
];



























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];






const wakadCabServiceSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Reliable and affordable cab service in Wakad Pune offering local and outstation taxis, airport transfers, corporate and family cab rentals with driver.",
  "areaServed": {
    "@type": "Place",
    "name": "Wakad, Pune"
  },
  "serviceType": [
    "Wakad Cab Service Pune",
    "Cab Booking Wakad Pune",
    "Taxi Service in Wakad",
    "Wakad Local Cab",
    "Affordable Cab in Wakad Pune",
    "Wakad Taxi with Driver",
    "Wakad Outstation Cab Service",
    "Wakad Airport Taxi",
    "Wakad Cab Rental",
    "Cab Service Near Wakad Pune",
    "Wakad Taxi Deals",
    "Wakad City Taxi",
    "Wakad Corporate Cab",
    "Wakad Cab Online Booking",
    "Wakad Family Cab Service"
  ],
  "telephone": "+91-XXXXXXXXXX"
};









    return (
        <div>

<Helmet>
  <title>Cab Service in Wakad Pune | Wakad Taxi Booking & Rental</title>
  <meta
    name="description"
    content="Reliable and affordable cab service in Wakad Pune offering local and outstation taxis, airport transfers, corporate and family cab rentals with driver."
  />
  <meta
    name="keywords"
    content="Wakad Cab Service Pune, Cab Booking Wakad Pune, Taxi Service in Wakad, Wakad Local Cab, Affordable Cab in Wakad Pune, Wakad Taxi with Driver, Wakad Outstation Cab Service, Wakad Airport Taxi, Wakad Cab Rental, Cab Service Near Wakad Pune, Wakad Taxi Deals, Wakad City Taxi, Wakad Corporate Cab, Wakad Cab Online Booking, Wakad Family Cab Service"
  />
  <script type="application/ld+json">
    {JSON.stringify(wakadCabServiceSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/66.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinwakadpune;